<script setup lang="ts" generic="T, MM">
import FormField from '@/components/input/FormField.vue'
import { Validation } from '@vuelidate/core'
import { VSelect } from 'vuetify/components'

export type SelectOption<T> = {
  title: string
  value: T
}

const props = defineProps<{
  label?: string
  validation?: Validation
  required?: boolean
}>()

const model = defineModel<T | undefined>()

defineOptions({ inheritAttrs: false })
</script>

<template>
  <form-field :label="props.label" :validation="props.validation" :required="props.required">
    <v-select v-bind="$attrs" v-model="model" hide-details @blur="props.validation?.$touch">
      <template v-for="(_, slot) of $slots" #[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-select>
  </form-field>
</template>
